// extracted by css-extract-rspack-plugin
export default {"noActionsAvailable":"UnclaimOrganization_noActionsAvailable__Xo3e4"};